import { useEffect, useRef, useState } from "react";

interface CountdownTimerProps {
  /** Duration in seconds */
  duration: number;
  /** Called when timer reaches zero */
  onTimeout: () => void;
}

/**
 * Countdown timer atom.
 * Pill shape with primary-110 border: "Quedan: mm:ss".
 */
export function CountdownTimer({ duration, onTimeout }: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(duration);
  const onTimeoutRef = useRef(onTimeout);
  useEffect(() => {
    onTimeoutRef.current = onTimeout;
  });

  useEffect(() => {
    setRemaining(duration);
  }, [duration]);

  useEffect(() => {
    if (remaining <= 0) {
      onTimeoutRef.current();
      return;
    }
    const timer = setInterval(() => {
      setRemaining((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [remaining]);

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  const timeStr = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return (
    <div
      className="inline-flex items-center gap-1 rounded-[20px] border border-primary-110 px-4 py-1.5"
      style={{ fontSize: 14 }}
    >
      <span className="text-primary-110">Quedan:</span>
      <span className="font-semibold text-primary-110">{timeStr}</span>
    </div>
  );
}
